import React from 'react';
import permissionLevel from '../services/permissions.js';

/**
 * 
 * @param {*} param0 
 */
const PermissionsComponent = ({ permission, accessType, level, children }) => (
    permissionLevel(permission, accessType).includes(level) ? 
        <React.Fragment>
            {children}
        </React.Fragment>
        : 
        null
);

export default PermissionsComponent;